// extracted by mini-css-extract-plugin
export default {"buttonsSection":"PlanHeader_buttonsSection__3P3kj"};